/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'

import Menu from '../../../components/CustomerClub/Menu'

import LineChart from '../../../components/Chart/LineChart-2'
import reportBigIcon from '../../../assets/svg/Report2.svg'

import reportIcon from '../../../assets/svg/Report.svg'
import { UserDate } from '../../../Data'
import { UserDate2 } from '../../../Data'

import { notify } from '../../../components/Toast'
import { ToastContainer } from 'react-toastify'

import FavoriteFoodTable from '../../../components/CustomerClub/ReportsLists/FavoriteFoodList'
import BestSallerTable from '../../../components/CustomerClub/ReportsLists/BestSeller'
import OffcodeTable from '../../../components/CustomerClub/ReportsLists/OffCode'
import { get } from '../../../services/http'
import { ToRial } from '../../../services/toRial'

function index() {
  document.title = 'گزارش'

  const [favoriteFoods, setFavoriteFoods] = useState()
  const [favoriteUsers, setFavoriteUsers] = useState()
  const [allSale, setAllSale] = useState(0)

  // eslint-disable-next-line no-unused-vars
  const [chartData, setChartData] = useState({
    labels: UserDate.map((data) => data.yaer),
    datasets: [
      {
        label: 'فروش هفتگی',
        data: UserDate.map((data) => data.userGain),
        backgroundColor: ['#1B629D'],
      },
      {
        label: 'فروش هفتگی',
        data: UserDate2.map((data) => data.userGain),
        backgroundColor: ['#1B629D'],
      },
    ],
  })

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/ccreport?token=${token}`).then(response => {
      console.log(response)
      setFavoriteFoods(response.data.foodSortable)
      setFavoriteUsers(response.data.userSortable)

      setChartData({ 
        labels: response.data.data.dateMonth.labels , 
        datasets: [
          { label: response.data.data.dateMonth.datasets[0].label, 
            data: response.data.data.dateMonth.datasets[0].data.map((data) => data),
            borderColor: '#000000',
            backgroundColor: response.data.data.dateMonth.datasets[0].backgroundColor,
          }, {
            label: response.data.data.dateTwoMonth.datasets[0].label, 
            data: response.data.data.dateTwoMonth.datasets[0].data.map((data) => data),
            borderColor: '#8C8C8C',
            backgroundColor: response.data.data.dateTwoMonth.datasets[0].backgroundColor,
          }
        ]
      })

      setAllSale(response.data.data.allSale)
    })
    .catch(error => {
      if (error) {
        notify('error', error)
      }
      notify('error', 'خطا در ارسال اطلاعات')
    })
  }, [token])

  const handlePageClickFavoriteFood = (event) => {
    
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'reports'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={reportIcon} alt='resturantIcon' />
              </div>
              <div className='text'>
                ‌‌گزارش‌ها
              </div>
            </div>
            <div className="left">
            </div>
          </div>

          <div className='analytics'>
            <div className="right">
              <div className='saleSection'>
                <div className='title'>
                  <span>میزان فروش کل :</span>
                </div>
                <div className='money'>
                  {ToRial(String(allSale))} تومان
                </div>
                <img src={reportBigIcon} alt="reportBigIcon" />
              </div>
              <div className='circleAnalytics'>
                <img src={reportBigIcon} alt="reportBigIcon" />
              </div>
            </div>
            <div className='lineChart'>
              <span>فروش ماهیانه</span>
              <LineChart chartData={chartData} />
            </div>
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right">
                محبوب‌ترین غذا‌ها یا نوشیدنی ها
              </div>
              <div className="left">
              </div>
            </div>

            <FavoriteFoodTable data={favoriteFoods} />
            <ReactPaginate 
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClickFavoriteFood}
              pageRangeDisplayed={5}
              pageCount={0}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right">
                برترین خریداران (بر حسب تعداد سفارش)
              </div>
              <div className="left">
              </div>
            </div>

            <BestSallerTable data={favoriteUsers} />
            <ReactPaginate 
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClickFavoriteFood}
              pageRangeDisplayed={5}
              pageCount={0}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>

          <div className='analytics' style={{ backgroundColor: '#1B629D', color: '#fff' }}>
            <div className=''>بهترین زمان خرید</div>
            <div className=''>از ساعت 18 تا 21</div>
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right">
                کدهای تخفیف (باشگاه مشتریان)
              </div>
              <div className="left">
              </div>
            </div>

            <OffcodeTable data={[]} />
            <ReactPaginate 
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClickFavoriteFood}
              pageRangeDisplayed={5}
              pageCount={0}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}

export default index